<div class="snack-bar">
  <div class="snack-bar__icon" [ngClass]="snackBar.iconClass">
  </div>
  <div class="snack-bar__message">{{snackBar.message}}</div>
</div>
